module.exports = __webpack_public_path__ + "static/media/main-stage-5-locked.2c6e650e.png";